import { Box } from '@mui/material';

interface IErrorBoxProps {
  width?: number;
  height?: number;
  sx?: any;
}

function ErrorBox({ width = 200, height = 40, sx = {} }: IErrorBoxProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        border: '2px solid red',
        width,
        height,
        borderRadius: 1.5,
        ...sx,
      }}
    ></Box>
  );
}

export default ErrorBox;
